import { render, staticRenderFns } from "./liveRoomControl.vue?vue&type=template&id=10c54cba&scoped=true&"
import script from "./liveRoomControl.vue?vue&type=script&lang=js&"
export * from "./liveRoomControl.vue?vue&type=script&lang=js&"
import style0 from "./liveRoomControl.vue?vue&type=style&index=0&id=10c54cba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c54cba",
  null
  
)

export default component.exports